module.exports = "https://trybtryb-legacy.web.app/img/gold-party.c288c055.webp";